import { render } from "./ProfileCard.vue?vue&type=template&id=d26880da&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=ts"
export * from "./ProfileCard.vue?vue&type=script&lang=ts"

import "./ProfileCard.vue?vue&type=style&index=0&id=d26880da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d26880da"

export default script